/* eslint-disable prettier/prettier */
import React from "react";

const NightIcon = ({ onClickHandle }: any) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g filter="url(#filter0_d_2479_4)">
      <rect x="4" y="4" width="16" height="16" rx="4" fill="#DAF3FF" />
    </g>
    <path
      d="M11.25 6.75C9.375 6.75 7.125 8.625 7.125 11.625C7.125 14.625 9.375 16.875 12.375 16.875C15.375 16.875 17.25 14.625 17.25 12.75C13.125 15.375 8.625 10.875 11.25 6.75Z"
      stroke="#0094D9"
      strokeWidth="0.8125"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <defs>
      <filter
        id="filter0_d_2479_4"
        x="0"
        y="0"
        width="24"
        height="24"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset />
        <feGaussianBlur stdDeviation="2" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_2479_4"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_2479_4"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
);

export default NightIcon;
